/**
 * @author yan st
 * @date 2022-08-16 08:40
 * @Description:
 */
import {qspost} from '@/plugins/axios'

/*
* 搜索
* */
export const searchResult = (keywords) => qspost('/index.php/index/Index/searchResult', {keywords})

/*
* 数据
* */
export const Index = (type,keywords) => qspost('/index.php/index/Index/index', {type,keywords})


/*
* 详情
* */
export const Detail = (id,test_log_id) => qspost('/index.php/index/Casese/detail', {id,test_log_id})


/*
*测试题目
* */
export const Test = (case_id) => qspost('/index.php/index/Test/detail', {case_id})


/*
*测试题提交
* */
export const Result = (case_id,answer) => qspost('/index.php/index/Result/detail', {case_id,answer})






































































